import { USER_API_URL } from '../constants';
import {
  handleAuthSuccess,
  handleAuthError,
  ERROR_MESSAGES,
  AuthResponse,
  isAuthResponseSuccess,
  isAuthResponseError
} from './authenticate';

export type ConvertGuestAttributes = {
  password?: string;
  first_name?: string;
  last_name?: string;
  cart_id?: string | null;
};

export type ConvertGuestParams = {
  accessToken: string | null;
  userId: string | null;
  values?: ConvertGuestAttributes;
};

export const convertGuest = ({ accessToken, userId, values }: ConvertGuestParams) => {
  return fetch(`${USER_API_URL}/v1/users/convert_guest/${userId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/vnd.api+json',
      authorization: accessToken ? `Bearer ${accessToken}` : ''
    },
    body: JSON.stringify({
      data: { id: userId, type: 'user', attributes: values }
    })
  })
    .then(response => response.json())
    .then((data: AuthResponse) => {
      if (isAuthResponseSuccess(data)) return handleAuthSuccess(data);

      if (isAuthResponseError(data)) return handleAuthError(data.errors[0]);

      throw new Error(ERROR_MESSAGES.default);
    });
};
